export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isHandling: (state) => state.isHandling,
  hasWallet: (state) => state.hasWallet,
  contract: (state) => state.contract,
};
